export const no = {
    admin: {
        user: 'Kundemodusvisning',
        userModeDescription:
            'Ved å aktivere denne modusen vil siden forhåndsvises slik den blir presentert for kundene.',
    },
    app: {
        forvalter: 'Eiendomsdashbord',
        mittleieforhold: 'Mitt leieforhold',
        openInSuperOffice: 'SuperOffice',
        verified: 'Verified',
        dynamics365: 'Dynamics 365',
        eiendomGpt: 'EiendomGPT',
    },
    auth: {
        authorizing: 'Logger inn...',
        loggingOut: 'Logger ut...',
        login: 'Logg inn',
        logout: 'Logg ut',
        // eslint:disable-next-line: max-line-length
        privacyDescription:
            'Ved å bruke denne siden godtar du at vi samler informasjon som brukes til å forbedre brukeropplevelsen for brukerne av denne siden. Les mer om personvern på vår ',
        privacyLinkTitle: 'personvernside',
        sessionTimeout: 'Din sesjon har utløpt',
        sessionTimeoutLoginAgain: 'Vennligst logg inn på nytt',
    },
    breadcrumbs: {
        availibleArea: 'Ledig Areal',
        building: 'Eiendom',
        byggUtleie: 'Utleie',
        contractManagement: 'Kontraktsforvaltning',
        checkOff: 'Avsjekk',
        expiringArea: 'Kontraktsutløp',
        dashboard: 'Mitt Leieforhold',
        invoice: 'Faktura',
        listUsers: 'Brukere',
        message: 'Oppslagstavle',
        registerUser: 'Registrer bruker',
        reports: 'Rapporter',
        searchUsers: 'Søk etter brukere',
        selectClient: 'Velg kundeforhold',
        supportApplicationForm: 'Søknad om støtte',
        ticket: 'Saker',
        forvaltningsplan: 'Forvaltningsplan',
        environmentProfile: 'Miljøprofil',
        keyFigures: {
            area: 'Arealnøkkeltall',
            economy: 'Økonomiske nøkkeltall',
        },
        project: {
            report: 'Prosjektrapport',
            schema: 'Prosjektskjema',
        },
        leverandor: {
            schema: 'Leverandørskjema',
            documentation: 'Dokumentasjon',
            leverandorReport: 'Leverandørrapport',
        },
    },
    bygg: {
        favoritt: 'Legg til favoritt',
        removeFavorite: 'Fjern favoritt',
        noBuildingsYet:
            'Du har ikke noen bygg enda, men du kan legge til bygg i favorittlisten via søkefeltet i toppmenyen.',
        myBuildings: 'Mine bygg',
        settings: {
            title: 'Innstillinger',
            saveChanges: 'Lagre endringer',
            showByggGrunn: 'Vis grunn i oversikt over bygg',
        },
    },
    chat: {
        tooltip: 'Chat med eiendomsdashbord om kontrakter',
    },
    comments: {
        title: 'Kommentarer: {{page}}',
        tooltip: 'Kommentarer',
        datePickerLabel: 'Velg år',
        chooseYearDescription: 'Velg hvilket år kommentaren gjelder',
        newComment: 'Ny kommentar',
        editComment: 'Rediger kommentar',
        edit: 'Rediger',
        delete: 'Slett',
        highlight: 'Fremhev',
        readMore: 'Les mer',
        resetHighlightsFrontpage: 'Tilbakestill fremheving på forside',
        close: 'Lukk',
        pin: 'Fest',
        titleLabel: 'Tittel',
        validation: {
            titleTooLong: 'Tittel kan ikke være lengre enn 50 tegn',
            titleOutOfRange:
                'Tittel kan ikke være kortere enn 1 tegn eller lengre enn 50 tegn',
        },
        seeDetails: 'Se detaljer',
        updatedBy: 'Oppdatert av:',
        edited: 'Sist redigert: ',
        published: 'Publisert: ',
    },
    editor: {
        paragraph: 'Avsnitt',
        heading1: 'Overskrift 1',
        heading2: 'Overskrift 2',
        heading3: 'Overskrift 3',
        heading4: 'Overskrift 4',
        heading5: 'Overskrift 5',
        heading6: 'Overskrift 6',
        horizontalRule: 'Horisontal linje',
        insertTable: 'Sett inn tabell',
        loadingEditor: 'Laster editor...',
        addColumnBefore: 'Ny kolonne før',
        addColumnAfter: 'Ny kolonne etter',
        deleteColumn: 'Slett kolonne',
        addRowBefore: 'Ny rad før',
        addRowAfter: 'Ny rad etter',
        deleteRow: 'Slett rad',
        deleteTable: 'Slett tabell',
    },
    contractFrame: {
        externalFrame: {
            actionButton: 'Åpne kontraktsforvaltning',
            contractNotFoundDescription:
                'Du kan finne alle dine gjeldende leiebetingelser under den respektive eiendomen',
            contractNotFoundLink: 'Gå til mine eiendommer',
            contractNotFoundTitle: 'Ser du etter dine leiebetingelser?',
            manualContractDescription:
                'Du kan få en kopi av dine kontrakter ved å kontakte din eiendomsforvalter hos KLP',
            manualContractTitle: 'Ser du etter en eksisterende PDF kontrakt?',
            description:
                'For å åpne den digitale kontraktsforhandlingen, må vi bruke en ny fane.',
            description2:
                'Trykk på knappen under, så åpner vi kontraktsforhandlingen for deg i en ny separat fane.',
            title: 'Skal du signere eller forhandle en ny digital kontrakt?',
        },
    },
    dxboFrame: {
        externalFrame: {
            actionButton: 'Åpne Prosjekter',
            description: 'For å åpne prosjekter, må vi bruke en ny fane',
            title: 'Prosjekter må åpnes i en ny fane',
        },
    },
    environment: {
        // tslint:disable-next-line: max-line-length
        description:
            'Denne tjenesten kan være ustabil i noen perioder. Vi utvikler og forbedrer den kontinuerlig og vi setter stor pris på alle dine tilbakemeldingene og forslag.',
        dev: 'DEV',
        environment: 'Miljø: ',
        title: 'Miljø',
        miljoprofil: 'Byggets miljøprofil',
        powerBi: 'Miljørapport',
        noContextSelected: 'Du må søke opp en byggavdeling før du kan se dette',
        local: 'LOCAL',
        test: 'TEST',
    },
    faktura: {
        payments: 'Betalinger',
    },
    file: {
        deleting_1: 'Sletter filen...',
        deleting: 'Sletter filene...',
        downloading: 'Laster ned...',
        downloadingFinished: 'Nedlasting fullført',
        fileNotFound: 'Filen finnes ikke',
        preview: 'Forhåndsvisning',
        previewDownload: 'FORHÅNDSVISNING    / LAST NED',
        downloadFailed: 'Nedlasting mislyktes',
        saving_1: 'Lagrer filen...',
        saving: 'Lagrer filene...',
        selectFiles_0: 'Velg fil',
        selectFiles: 'Velg filer',
    },
    availableArea: {
        availableArea: 'Ledig areal',
        availableAreaValue: 'Ledig markedsverdi',
        downloadSourceData: 'Last ned Ledige lokaler til Excel',
        filedownloadname: 'Ledig_Areal{{lastname}}{{region}}.xlsx',
        potentialRevenue: 'Markedsverdi ledig areal',
        totalArea: 'Totalareal',
        table: {
            areaType: 'TYPE',
            buildingAddress: 'ADRESSE',
            buildingNo: 'NR.',
            floor: 'ETASJE',
            leaseObject: 'LEIEOBJEKT',
            leaseObjectId: 'LEIEOBJEKT ID',
            markedsprisLedigAreal: 'MARKEDSVERDI (NOK)',
            markedsprisPerM2: 'ENHETSPRIS',
            physicalArea: 'AREAL',
            property: 'EIENDOM',
            plotId: 'GRUNNID',
            roomNo: 'SONE NR',
            noMatch:
                'Vi fant ingen ledige lokaler i byggavdelingen{{buildingName}} og / eller porteføljen du har valgt',
        },
    },
    expiringContracts: {
        expirationProfile: {},
        keyFigures: {
            availableArea: 'Ledig areal',
            availableAreaValue: 'Ledig markedsverdi',
        },
        table: {
            amountYear: 'ÅRSPRIS',
            area: 'AREAL',
            areaType: 'TYPE',
            contractHeadExpiryDate: 'UTLØP',
            contractLineExpiryDate: 'LINJEUTLØP',
            contractNumber: 'KONTRAKT',
            customerName: 'KUNDE',
            customerNumber: 'KUNDENUMMER',
            description: 'BESKRIVELSE',
            filterReset: 'Fjern filter',
            filterTitle: 'Filtre:',
            noMatch:
                'Vi fant ingen utløpende kontrakter for byggavdelingen{{buildingName}} og / eller porteføljen du har valgt',
            pricePerAmount: 'NOK/STK',
            pricePerSquareMeter: 'NOK/m²',
            pricePerUnit: 'ENHETSPRIS',
            property: 'EIENDOM',
            sortingWeight: 'PRIORITET',
            sortingWeightChipText: 'Prioritet',
        },
        downloadSourceData: 'Last ned utløpende kontrakter til Excel',
        filedownloadname:
            'Utløpende_Kontrakter{{lastname}}{{region}}{{from}}{{to}}.xlsx',
    },
    checkOffContract: {
        title: 'Kontrakt {{kontraktnavn}}',
        signed: 'Signert: ',
        sender: 'Avsender: ',
        noSender: 'Ingen avsender',
        subTitle: '{{kundeNavn}} ({{kundeNummer}})',
        tableDescription:
            'Registrerte kontraktlinjer for {{kundeNavn}} ({{kundeNummer}})',
        receivers: 'Mottakere:',
        noReceivers: 'Ingen underskrivere.',
        noDocuments:
            'Ingen dokumenter har blitt lastet opp for denne kontrakten.',
        subTitlePartTwo: 'for kunde',
        subTitlePartThree: 'til D365 kontraktlinjer?',
        saveButton: 'Lagre',
        saveButtonCompletedStep: 'Deling Mittleieforhold',
        cancelButton: 'Avbryt',
        backButton: 'Tilbake til registreringsoversikten',
        document: 'Dokument:',
        missingDocument:
            'Dette dokumentet er dessverre ikke tilgjengelig for nedlastning og visning',
        registerInD365: 'Registrer kontrakt i D365:',
        registreringProsessLink: 'Gå til registrering for: {{type}}',
        processHeader: {
            Kontrakt: 'Registrer kontrakt i D365:',
            Garanti: 'Registrer garanti',
            Innflytningsprotokoll: 'Registrer innflytting',
            Utflytningsprotokoll: 'Registrer utflytting',
        },
        error: 'Det oppstod en feil under uthenting av kontraktsdokument. Vennligst prøv igjen senere.',
        tooltip:
            'Knappen er deaktivert siden forrige steg ikke er fullført, eller fordi nåværende steg allerede er fullført.',
        tooltipSendButton:
            'Knappen er deaktivert siden kontraktsdokumentet mangler kontraktslinjer.',
        shareButtonCompleted: 'Endre deling til Mitt Leieforhold',
        shareButton: 'Deling til Mitt Leieforhold',
        startRegistrationButton: 'Start registrering',
        successfulSending: 'Kontraktsdokumentet har blitt delt.',
        shareDocumentHeading: 'Del kontraktsdokument - {{kontraktnavn}}',
        secondaryTitle:
            'Knytt kontraktsdokumentet for {{kundeNavn}} ({{kundeNummer}}) mot registrerte kontraktslinjer',
        shareDocumentWarning:
            'NB! Del kun kontraktsdokument som allerede er registrert i D365',
        dialog: {
            title: 'Er du sikker på at du ønsker å tildele til den valgte konsulenten?',
            stepCompletion: 'Er du sikker på at du ønsker å fullføre steget?',
        },
        notStartedActivity: 'Oppgaven er ikke startet.',
        insufficientUserRole:
            "Oppgaven krever rollen(e) '{{role}}', du er ikke tildelt denne rollen.",
        completedActivity: 'Oppgaven ble utført av: {{name}}, {{date}}',
        adminInformation:
            "Oppgaven krever rollen '{{role}}' og er tildelt '{{assigned}}'. Du har admin-rolle og kan endre/utføre oppgaven.",
        roles: {
            Okonomi: 'Økonomi',
            QAOkonomi: 'Økonomi QA',
            Forvalter: 'Forvalter',
        },
        step: {
            // Vurder relevans
            Activity_1vr6y7a: {
                title: 'Vurder relevans',
                secondaryTitle: 'Er dokumentet relevant for registrering?',
                description:
                    'Ikke alle dokumenter fra Verified skal registreres. Velg «Relevant» dersom dokumentet er en kontrakt, innflyttingsprotokoll eller utflyttingsprotokoll, og velg deretter dokumenttype. Velg «Ikke relevant» dersom dokumentet ikke er en av disse, eller ikke er relevant.',
                notRelevantButton: 'Ikke relevant',
                relevantButton: 'Relevant',
                cta: 'Fullfør steg',
                completeButton: 'Fullfør',
                completedBy: 'Utført av: {{name}}, {{date}}',
            },
            // Tildel økonomikonsulent
            Activity_1rdcqtp: {
                title: 'Tildel økonomikonsulent',
                secondaryTitle: 'Velg økonomikonsulent',
                tertiaryTitle: 'Velg konsulent',
                descriptionPartOne:
                    'Vi har valgt byggets økonomikonsulent for deg.',
                descriptionPartTwo:
                    'Trenger du å endre dette, kan du gjøre det her.',
                cta: 'Tildel',
                chosenConsultant: 'Valgt konsulent:',
                completedBy: 'Utført av: {{name}}, {{date}}',
            },
            sendToRegistration: {
                title: 'Send til registrering',
                secondaryTitle: 'Registrering i Dynamics 365',
                descriptionPartOne:
                    'Vi har sendt et varsel til {{navn}}, som vil registrere kontrakten i D365.',
                descriptionPartTwo:
                    'Du vil få et varsel når kontrakten er ferdig registrert.',
                cta: 'Fullfør steg',
                completedBy: 'Utført av: {{name}}, {{date}}',
            },
            // Utfør registrering i D365
            Activity_0hw9rg3: {
                title: 'Registerer i D365',
                secondaryTitle: 'Registrering i Dynamics 365',
                tertiaryTitle: 'Velg konsulent',
                levendeKontrakterDescription:
                    'Basert på informasjon fra Levende Kontrakter, har vi opprettet et utkast til ny kunde, {{kundeNavn}}, og et uktast til registrering av denne nye kontrakten ({{kundeNummer}}) til Onsite 365.',
                description:
                    'Kontroller innholdet i utkastet og ferdigstill registreringen.',
                goToCustomer: 'Gå til kunde',
                goToContractDraft: 'Gå til kontrakt',
                goToLevendeKontrakter: 'Gå til Levende Kontrakter',
                errorStatusNewCustomer: 'Klarte ikke å opprette en ny kunde',
                errorStatusNewContractDraft:
                    'Klarte ikke å opprette en ny kontrakt',
                D365Button: 'Åpne Onsite365',
                cta: 'Fullfør steg',
                completeButton: 'Fullfør',
                selectController: 'Velg kontrollør for registreringen',
                chosenConsultant: 'Valgt konsulent:',
                completedBy: 'Utført av: {{name}}, {{date}}',
            },
            // Kontroll av registrering i D365
            Activity_1bk3epl: {
                title: 'Kontroll av registrering i D365',
                descriptionPartOne:
                    'Er kontrakten korrekt registrert i D365, kan den godkjennes.',
                approveRegistrationButton: 'Godkjenn registrering',
                cta: 'Fullfør steg',
                controlRegistration: 'Kontroller registrert kontrakt',
                goToLevendeKontrakter: 'Gå til Levende Kontrakter',
                goToCustomer: 'Gå til kunde',
                goToContractDraft: 'Gå til kontrakt',
                D365Button: 'Åpne Onsite365',
                completedBy: 'Utført av: {{name}}, {{date}}',
            },
            notifyManager: {
                title: 'Varsle forvalter',
            },
            // Vurder gjennomgangsmøte
            Activity_1b84rij: {
                title: 'Vurder gjennomgangsmøte',
                description:
                    'Er det en større kontrakt, kan det være nødvendig å ta et gjennomgangsmøte med forvalter.',
                reviewMeetingButton: 'Gjennomgangsmøte',
                continueButton: 'Fortsett',
                cta: 'Fullfør steg',
                completedBy: 'Utført av: {{name}}, {{date}}',
            },
            // Gjennomgangsmøte
            Activity_1m3ak5n: {
                title: 'Gjennomgangsmøte',
                descriptionPartOne:
                    'Økonomi er nå ferdig med å registrere kontrakten i D365, og ønsker et gjennomgangsmøte.',
                descriptionPartTwo:
                    'Forbered deg til møtet ved å se gjennom faktura-utkastet til kunde.',
                previewButton: 'Forhåndsvis Faktura',
                approveRegistrationButton: 'Godkjenn registrering',
                cta: 'Fullfør steg',
                completedBy: 'Utført av: {{name}}, {{date}}',
            },
            // Oppdater kundenummer i SuperOffice
            Activity_057tcgr: {
                title: 'Oppdater kundenummer i SuperOffice',
                descriptionPartOne:
                    'Gå inn på denne lenken for å oppdatere kundenummeret.',
                descriptionPartTwo:
                    'Dersom kundenummer korrekt registrert, kan du fullføre nåværende steg og fortsette registreringen.',

                descriptionPartThree:
                    'Dette kreves for å se oversikt over kontraktlinjer for kontraktdokumentet.',
                goToSuperOffice: 'Gå til SuperOffice',
                cta: 'Fullfør steg',
                completedBy: 'Utført av: {{name}}, {{date}}',
            },
            // Knytt dokument og linje
            Activity_15vq4i6: {
                title: 'Knytt dokument og linje',
                secondaryTitle:
                    'Registrerte kontraktlinjer for {{kundeNavn}} ({{kundeNummer}})',
                table: {
                    validToDate: 'TIL',
                    validFromDate: 'FRA',
                    amount: 'ANTALL',
                    areal: 'AREAL',
                    yearlyPrice: 'NOK/ÅR',
                    kontraktId: 'KONTRAKTSNUMMER',
                    id: 'ID',
                    name: 'NAVN',
                    choose: 'VELG',
                    noRelevantContractLines:
                        'Vi fant ingen relevante kontraktlinjer for kunden innenfor signeringsperioden.',
                },
                cta: 'Fullfør steg',
                completedBy: 'Utført av: {{name}}, {{date}}',
            },
            complete: {
                title: 'Ferdigstill',
                secondaryTitle: 'Registreringsammendrag',
                table: {
                    tenant: 'Leietaker',
                    area: 'Areal',
                    leaseStart: 'Leiestart',
                    invoiceAmount: 'Fakturabeløp',
                    property: 'Eiendom',
                    parking: 'Parkering',
                    endOfLease: 'Leieslutt',
                    invoiceDate: 'Fakturadato',
                },
                completeRegistration: 'Ferdigstill registrering',
                cancel: 'Avbryt',
                completedBy: 'Utført av: {{name}}, {{date}}',
            },
        },
        table: {
            validToDate: 'TIL',
            validFromDate: 'FRA',
            amount: 'ANTALL',
            areal: 'AREAL',
            yearlyPrice: 'NOK/ÅR',
            kontraktId: 'KONTRAKTSNUMMER',
            kontraktLinjeIds: 'ID',
            name: 'NAVN',
            choose: 'VELG',
            noRelevantContractLines:
                'Vi fant ingen relevante kontraktlinjer for kunden innenfor signeringsperioden.',
        },
    },
    contractRegistration: {
        oppslag: {
            sokLabel: 'Søk (kundenavn eller kundenummer)',
            sokUtenFiltre:
                'Søker i alle kontrakter. Andre filtre er slått av ved søk.',
        },
        contractTypes: {
            Kontrakt: 'Kontrakt',
            Garanti: 'Garanti',
            Innflytningsprotokoll: 'Innflytting',
            Utflytningsprotokoll: 'Utflytting',
        },
        statuses: {
            checkedOff: 'Avsjekket',
            notCheckedOff: 'Ikke avsjekket',
            new: 'Ny',
            shallNotBeRegistered: 'Skal ikke registreres',
            withForvalter: 'Hos forvalter',
            assignedFinance: 'Tildelt økonomi',
            registrationD365: 'Registrering D365',
            forApporval: 'Til godkjenning ',
            toQA: 'Til QA',
            QACompleted: 'QA fullført',
            approved: 'Godkjent',
            completed: 'Fullført',
            RegistreringAvGaranti: 'Garantiregistrering',
        },
        table: {
            actionMenuItems: {
                restartProcess: 'Restart prosess',
                showDetails: 'Se detaljer',
                assignFinancePerson: 'Tildel øko. ansv.',
                download: 'Last ned',
                notRelevant: 'Ikke relevant',
            },
            statusCode: {
                title: 'STATUS',
                warning: 'Vi finner ingen registrering i SuperOffice',
                noPropertyWarning:
                    'Vi finner ingen informasjon om eiendommen på denne kontrakten. En vanlig årsak er at dokumentet i SuperOffice ikke er knyttet til et prosjekt eller et salg.',
                noEconomyWarning:
                    'Vi finner ikke eiendommens økonomiansvarlig. En vanlig årsak er at dokumentet i SuperOffice ikke er knyttet til et prosjekt eller et salg.',
                noTenantWarning:
                    'Vi finner ingen leietaker på denne kontrakten. En vanlig årsak er at dokumentet er opprettet i Verified og ikke i SuperOffice eller at kontakten ikke er opprettet.',
            },
            contracts: {
                statusCode: {
                    success:
                        'Vi har funnet én ny registrering for denne kunden',
                    foundMultiple:
                        'Vi har funnet flere nye registreringer på denne kunden innen 14 dager fra signering. Dobbeltsjekk med økonomiansvarlig at denne kontrakten er registrert',
                    foundMultipleWithCount:
                        'Vi har funnet {{count}} nye registreringer på denne kunden innen 14 dager fra signering. Dobbeltsjekk med økonomiansvarlig at denne kontrakten er én av disse.',
                    notFound: 'Vi finner ikke noe informasjon.',
                    error200:
                        'Vi kan ikke finne noen mottakere for dokumentet i Verified eller Superoffice.',
                    error302:
                        'Vi kan ikke finne kundenummer. Kundenummer kan være feil i Superoffice eller det finnes ikke noen kontakter som matcher mottakerne.',
                    error300:
                        'Vi kan ikke finne en match med kontrakt. Enten er ikke kontrakten signert enda eller den er nettopp signert. Det kan ta opp til 14 dager fra signering før den er synlig.',
                    error303:
                        'Vi fnner ikke match på kontrakt. Hvis det har gått mer enn 14 dager mellom signering og registrering vil den ikke dukke opp her. Du kan kontakte økonomiansvarlig for mer informasjon.',
                    error301: 'Vi kan ikke finne byggnummer.',
                    error100:
                        'Vi kan ikke finne en referanse til dokumentet. Dokumentet er ikke registrert via Verified eller Superoffice, men har blitt lastet opp i Superoffice.',
                },
            },
            checkOff: 'AVSJEKK',
            contractDocument: 'DOKUMENT',
            economyPerson: 'ØKONOMI',
            property: 'EIENDOM',
            propertyManager: 'FORVALTER',
            registeredDate: 'Registrert D365',
            signDate: 'SIGNERT',
            tenant: 'LEIETAKER',
            kundeNummer: 'KUNDENUMMER',
            action: 'HANDLING',
            type: 'TYPE',
            email: {
                helpTextForvalter: 'Send mail til byggets forvalter',
                helpTextOkonomi: 'Send mail til byggets økonomiansvarlig',
                subjectText: 'Registrering av kontrakt i ',
            },
            emptyTableMessage:
                'Vi finner ingen kontrakter for byggavdelingen og / eller porteføljen du har valgt.',
        },
        title: 'D365 registreringsoppfølging',
        notification: 'Behandler forespørselen. Vennligst vent..',
        error: 'Det oppstod en feil. Prøv igjen senere.',
        errorSaveForm: 'Det skjedde en feil ved lagring av innhold i skjema.',
        successfulRegistration: 'Kontraktdokumentet har blitt registrert.',
        successfulOperation: 'Handlingen ble utført.',
        newProcess: 'Nye dokumenter',
        ongoingProcessForvalter: 'Hos forvalter',
        ongoingProcessFinance: 'Hos økonomi',
    },
    contractManagement: {
        leko: 'Forhandling',
        negotiation: 'Forhandling',
        overview: 'Avtaler',
        registrer: 'Registrering',
        sign: 'Signering',
        title: 'Kontraktsforvaltning',
        ongoingProcesses: 'Pågående prosesser',
        forSigning: 'Til signering',
        forRegistration: 'Til registrering',
    },
    contract: {
        amountYear: 'Kr/år',
        area: 'Areal',
        chartTitle: 'Utløpsprofil:',
        contractExpiry: 'Utløp',
        customerName: 'Kunde',
        expiringArea: 'Utløpende areal',
        expiringContracts: 'Utløpende kontrakter',
        expiringContractValue: 'Utløpende leieinntekter',
        expiringLines:
            '{{contractCount}} kontraktlinjer utløper mellom {{from}} og {{to}}:',
        expiry: {
            expired: 'Har utløpt',
            expires_within_1y: 'Utløper innen 1 år',
            expires_within_2y: 'Utløper innen 2 år',
            expires_within_3y: 'Utløper innen 3 år',
            expires_within_4y: 'Utløper innen 4 år',
            expires_within_6m: 'Utløper innen 6 mnd',
            eternal: 'Ingen utløpsdato',
        },
        expiryProfileTime: {
            expired: 'Utløpsprofil (Har utløpt):',
            expires_within_6m: 'Utløpsprofil (6 mnd):',
            expires_within_1y: 'Utløpsprofil (1. år):',
            expires_within_2y: 'Utløpsprofil (2 år):',
            expires_within_3y: 'Utløpsprofil (3 år):',
            expires_within_4y: 'Utløpsprofil (4 år):',
            eternal: 'Utløpsprofil (Ingen utløpsdato):',
        },
        keyFiguresTime: {
            expired: 'Nøkkeltall (Har utløpt):',
            expires_within_6m: 'Nøkkeltall (6 mnd):',
            expires_within_1y: 'Nøkkeltall (1. år):',
            expires_within_2y: 'Nøkkeltall (2 år):',
            expires_within_3y: 'Nøkkeltall (3 år):',
            expires_within_4y: 'Nøkkeltall (4 år):',
            eternal: 'Nøkkeltall (Ingen utløpsdato)',
        },
        expiryRateNOK: 'Utløpsgrad (NOK)',
        income: 'Leieinntekter',
        keyFigures: 'Nøkkeltall ({{date}}):',
        leasedArea: 'Utleid areal',
        lineExpiry: 'Detaljutløp',
        lineName: 'Beskrivelse',
        number: 'Kontrakt Nr.',
        pcs: 'stk',
        portfolioComposition: 'Porteføljesammensetning:',
        property: 'Eiendom',
        rentalStatusPerDate: 'Utleiestatus ({{date}}):',
        selectExpiry: 'Velg utløp',
        sortingWeight: ' ',
        title: 'Kontrakt',
        totalArea: 'Totalareal',
        totalPotentialIncome: 'Total potensiell leie',
    },
    ledigAreal: {
        keyFigures: {
            areaAvailable: 'Ledig areal',
            areaLeased: 'Utleid areal',
            availableAreaValue: 'Markedsverdi',
            rentalIncome: 'Leieintekter',
            totalArea: 'Totalareal',
            totalPotentialIncome: 'Total potensial leie',
        },
        areaAvailable: 'Ledig areal',
        areaLeased: 'Utleid areal',
        areaRatio: 'Arealmessig utleiegrad',
        areaToExpire: 'Utløpende areal',
        areaType: 'Type',
        buildingAddress: 'Adresse',
        buildingNo: 'Nr.',
        floor: 'Etasje',
        leaseObject: 'Leieobjekt',
        leaseObjectId: 'Leieobjekt Id',
        markedsprisLedigAreal: 'Markedsverdi (NOK)',
        markedsprisPerM2: 'NOK/m²',
        physicalArea: 'Areal',
        plotId: 'GrunnID',
        property: 'Eiendom',
        roomNo: 'SoneNr',
        section: 'Seksjon',
        title: '{{count}} lokaler er ledige',
    },
    portfolio: {
        all: 'Alle porteføljer',
        select: 'Velg portefølje',
    },
    region: {
        all: 'Alle regioner',
        select: 'Velg region',
    },
    filterPanel: {
        nullstill: 'Nullstill',
        alle: 'Alle',
        portefolje: 'Portefølje',
        region: 'Region',
        status: 'Status',
        endretEtter: 'Endret etter',
        signertEtter: 'Signert etter',
        antall: 'Maks antall',
        tomFelt: 'Tøm feltet',
        laster: 'Laster',
        tildeltMeg: 'Tildelt meg',
        visTildelt:
            'Viser skjema som er tildelt deg. Søk og andre filtre er slått av.',
        sokUtenFiltre: 'Søker i alle skjema. Andre filtre er slått av ved søk.',
        velgFilter: 'Søk, eller velg minst ett filter for å vise skjema.',
    },
    status: {
        all: 'Alle statuser',
        select: 'Velg status',
        filter: 'Filtrer',
        selectedCount: '{{antall}} valgt',
    },
    keyfigures: {
        title: 'Nøkkeltall',
        areaTitle: 'Areal',
        economyTitle: 'Økonomisk',
        noContextSelected: 'Du må søke opp en byggavdeling før du kan se dette',
    },
    forvaltningsplan: {
        title: 'Forvaltningsplan',
        noContextSelected: 'Du må søke opp en byggavdeling før du kan se dette',
        edit: 'Rediger',
        read: 'Les',
    },
    users: {
        title: 'Brukeroversikt',
        searchField: 'Søk etter bruker',
        fullname: 'Navn',
        email: 'Epost',
        roles: 'Roller',
        region: 'Region',
        noUsers: 'Ingen brukere funnet.',
        editUser: {
            title: 'Administrer bruker',
            titleWithName: 'Administrer bruker: {{name}}',
            backButton: 'Tilbake til brukeroversikten',
            assignRoles: 'Tildel roller',
            rolesDescription: 'Legg inn hvilke roller brukeren har',
            assignRegion: 'Tildel region',
            regionDescription: 'Legg inn hvilken region brukeren tilhører',
            regionRequired: 'Region er påkrevd',
        },
        showUserInfo: {
            title: 'Vis brukerinfo',
            secondaryTitle: 'Brukerinfo for {{name}}',
            backButton: 'Tilbake til brukeroversikten',
            labelRoles: 'Roller',
            rolesDescription: 'Brukeren har følgende roller',
            labelRegion: 'Region',
            regionDescription: 'Brukeren tilhører følgende region',
            prosjektkontrollerDescription:
                'Brukeren er ansvarlig for følgende byggavdelinger og firma som prosjektkontroller',
            labelBygg: 'Byggavdelinger',
            labelFirma: 'Firma',
        },
        action: {
            label: 'Handling',
            byggProsjektkontroller: 'Endre bygg for prosjektkontroller',
        },
        bpkModal: {
            title: 'Rediger byggavdelinger og firma for prosjektkontroller',
            description:
                'Legg inn byggavdelinger og firma som brukeren er ansvarlig for som prosjektkontroller',
            assigned: 'tildelt',
            labelBygg: 'Velg byggavdelinger',
            labelFirma: 'Velg firma',
            save: 'Lagre',
            assignedByggWarning: 'Følgende bygg vil bli overført til {{name}}',
            assignedFirmaWarning:
                'Følgende firma vil bli overført til {{name}}',
            saveCompletion:
                'Er du sikker på at du ønsker å overføre {{values}} til {{name}}?',
        },
        save: 'Lagre',
        regionSelector: {
            Danmark: 'Danmark',
            Trondheim: 'Trondheim',
            Oslo: 'Oslo',
            Sverige: 'Sverige',
            Alle: 'Alle',
            Europa: 'Europa',
        },
        rolesSelector: {
            Teamleder: 'Teamleder',
            Drift: 'Drift',
            Forvalter: 'Forvalter',
            Okonomi: 'Økonomi',
            OkonomiQA: 'Økonomi QA',
            Prosjekteier: 'Prosjekteier',
            Prosjektleder: 'Prosjektleder',
            Prosjektkontroller: 'Prosjektkontroller',
            Prosjektdirektor: 'Prosjektdirektør',
            Forvaltningsdirektor: 'Forvaltningsdirektør',
            Utviklingsdirektor: 'Utviklingsdirektør',
            Administrerendedirektor: 'Administrerende direktør',
            Okonomisjef: 'Økonomisjef',
            Teknisksjef: 'Teknisksjef',
            'user-admin': 'Brukeradministrator',

            Avdelingsleder: 'Avdelingsleder',
            Ledergruppedirektor: 'Ledergruppedirektør',
            Risikovurderer: 'Risikovurderer',
            Leverandoroppretter: 'Leverandøroppretter',
            FagansvarligAapenhetsloven: 'Fagansvarlig Åpenhetsloven',
            Eiendomssjef: 'Eiendomssjef',
            Regiondirektor: 'Regiondirektør',
        },
    },
    formGenerator: {
        approve: 'Godkjenn',
        disapprove: 'Avvis',
        submit: 'Fullfør oppgaven',
        fieldRequired: 'Dette feltet er påkrevd',
        maxLengthExceeded: 'Teksten kan ikke være lengre enn {{max}} tegn',
        characterCount: '{{length}} / {{max}} tegn',
        assign: {
            title: 'Trenger du hjelp til å fylle ut skjemaet?',
            description:
                'Tildel oppgaven "{{oppgave}}" til en kollega med riktig rolle ({{rolle}}) for å få hjelp til å fylle ut skjemaet.',
            assignTo: 'Tildel til',
        },
        confirmDialog: {
            confirmDisapproval: 'Er du sikker på at du vil avvise skjemaet?',
            confirm: 'Ja, avvis',
        },
        roles: {
            Teamleder: 'Teamleder',
            Drift: 'Drift',
            Forvalter: 'Forvalter',

            Bestiller: 'Bestiller',
            Avdelingsleder: 'Avdelingsleder',
            Ledergruppedirektor: 'Ledergruppedirektør',
            Risikovurderer: 'Risikovurderer',
            Leverandoroppretter: 'Leverandøroppretter',

            Prosjekteier: 'Prosjekteier',
            Prosjektleder: 'Prosjektleder',
            Teknisksjef: 'Teknisk sjef',
            Eiendomssjef: 'Eiendomssjef',
            Forvaltningsdirektor: 'Forvaltningsdirektør',
            Prosjektdirektor: 'Prosjektdirektør',
            Utviklingsdirektor: 'Utviklingsdirektør',
            Regiondirektor: 'Regiondirektør',
            Administrerendedirektor: 'Administrerende direktør',

            Okonomi: 'Regnskapsansvarlig',
            Prosjektkontroller: 'Prosjektkontroller',
            OkonomiQA: 'Økonomi QA',
            Okonomisjef: 'Økonomisjef',

            'user-admin': 'Brukeradministrator',
        },
        unsupportedFieldType: {
            title: 'Ikke-støttet felttype',
            message:
                'Feltet du prøver å vise støttes ikke i dette skjemaet. Vennligst sjekk felttypen eller kontakt support.',
            reloadButton: 'Last inn skjema på nytt',
        },
    },
    leverandor: {
        oppslag: {
            sokLabel: 'Søk (leverandørnummer, org.nummer eller org.navn)',
        },
        title: 'Leverandørstyring',
        heading: 'Leverandørskjema',
        placeholder: 'Leverandørliste kommer her',
        abort: 'Avbryt',
        review: 'Gjennomgang',
        opprettetAv: 'Opprettet av',
        completedBy: 'Utført av: {{name}}\n{{date}}',
        completedDate: 'Utført: {{date}}',
        ansvarlig: 'Ansvarlig: {{name}}',
        menuItems: {
            leverandor: 'Leverandørliste',
            root: 'Leverandør',
            skjema: 'Skjema',
            leverandorReport: 'Leverandørrapport',
        },
        noContextSelected: 'Du må søke opp en leverandør før du kan se dette',
        notFound:
            'Leverandøren du prøver å åpne finnes ikke. Vennligst gå tilbake til oversikten og velg en leverandør fra listen.',
        backButton: 'Tilbake til leverandøroversikten',
        header: {
            documentation: 'Dokumentasjon',
        },
        cantFindProjectSchema:
            'Det oppstod en feil. Fant ikke leverandørskjema',
        activityAssignedToOtherUser:
            "Oppgaven er tildelt '{{assigned}}', du kan derfor ikke endre/utføre oppgaven.",
        assignActivityToMe: 'Tildel oppgaven til meg',
        insufficientUserRole:
            "Oppgaven krever rollen '{{role}}', du er ikke tildelt denne rollen.",
        adminInformation:
            "Oppgaven krever rollen '{{role}}' og er tildelt '{{assigned}}'. Du har admin-rolle og kan endre/utføre oppgaven.",
        completedActivity: 'Oppgaven er allerede utført.',
        rejectedActivity: 'Skjemaet er avvist.',
        skipActivity:
            'Denne oppgaven er ikke relevant for flyten og vil bli hoppet over',
        deviationSystemLink: 'Link til avvikssystem',
        processDefinition: {
            breadcrumb: 'Flytdiagram',
            back: 'Tilbake til dokumentasjon',
            title: 'Visuell fremstilling av flytdiagram for prosessdefinisjon: {{processDefinitionId}}',
            iconTitle:
                'Se mer detaljert fremstilling av flytdiagram for prosessdefinisjoner',
            documentationTitle:
                'Dokumentasjon av flytdiagram for prosessdefinisjoner',
            selector: 'Velg prosessdefinisjon',
            helperText: 'Velg prosessdefinisjon for å filtrere leverandører',
            zoomIn: 'Zoom inn',
            zoomOut: 'Zoom ut',
            resetZoom: 'Nullstill zoom',
            read: 'Åpne ekstern lenke til Confluence side for prosessdefinisjon(er)',
        },
        table: {
            emptyTableMessage: 'Ingen leverandører funnet',
            orgnummer: 'ORGNUMMER',
            superOfficeContactId: 'Leverandør SO ID',
            d365Leverandornummer: 'Leverandørnummer',
            superOfficeDocumentId: 'SuperOffice Dokument ID',
            navn: 'Navn',
            type: 'Type',
            bestiller: 'Bestiller',
            okonomi: 'Økonomi',
            ansvarlig: 'Tildelt til',
            opprettetAv: 'Opprettet av',
            startDato: 'Startdato',
            fullfortDato: 'Fullført dato',
            action: 'Handlinger',
            status: 'Status',
            aktivitet: 'Oppgave',
            klassifisering: 'Klassifisering',
            feltOppdateringFeilet: 'Kunne ikke oppdatere feltet {{fieldName}}',
            ugyldigJSONBransje:
                'Feltet for bransje inneholder ugyldig data, og kan ikke leses.',
            ugyldigJSONKlassifisering:
                'Feltet for klassifisering inneholder ugyldig data, og kan ikke leses.',
            actionMenuItems: {
                currentHeader: 'Handlinger for skjema',
                visLeverandorSkjema: 'Vis skjema',
                dokumentasjon: 'Vis dokumentasjon',
                lastNedDokument: 'Last ned dokument',
                forhaandsvisDokument: 'Forhåndsvis dokument',
                tildel: 'Tildel ny ansvarlig',
                sendReminder: 'Send påminnelse til ansvarlig',
                sendKommentar: 'Send kommentar til rolleinnehaver',
            },
            tildelAnsvarlig: {
                title: 'Tildel ny ansvarlig',
                ansvarlig: 'Ansvarlig',
                tildel: 'Tildel',
                avbryt: 'Avbryt',
            },
            roller: {
                Bestiller: 'Bestiller',
                Avdelingsleder: 'Avdelingsleder',
                Ledergruppedirektor: 'Ledergruppedirektør',
                Risikovurderer: 'Risikovurderer',
                Leverandoroppretter: 'Leverandøroppretter',
                FagansvarligAapenhetsloven: 'Fagansvarlig Åpenhetsloven',
                Okonomi: 'Økonomi',

                Prosjekteier: 'Prosjekteier',
                Prosjektleder: 'Prosjektleder',
                Forvaltningsdirektor: 'Forvaltningsdirektør',
                Utviklingsdirektor: 'Utviklingsdirektør',
                Administrerendedirektor: 'Administrerende direktør',
                Prosjektdirektor: 'Prosjektdirektør',
                Okonomisjef: 'Økonomisjef',
                Prosjektkontroller: 'Prosjektkontroller',
                Teknisksjef: 'Teknisk sjef',
                Eiendomssjef: 'Eiendomssjef',
                Regiondirektor: 'Regiondirektør',

                Ukjent: 'Ingen roller',
            },
            registreringStatus: {
                UnderVurdering: 'Under vurdering',
                Avvist: 'Avvist',
                Fullfort: 'Fullført',
            },
        },
        statuses: {
            UnderVurdering: 'Under vurdering',
            Fullfort: 'Fullført',
            Avvist: 'Avvist',
        },
        displayStatuses: {
            underGodkjenning: 'Under Godkjenning',
            godkjent: 'Godkjent',
            ikkeGodkjent: 'Ikke Godkjent',
        },
        successfulRegistration: 'Leverandøren har blitt registrert.',
        successfulOperation: 'Handlingen ble utført vellykket.',
        notAssignedToUser:
            'Du er ikke tildelt denne oppgaven og kan derfor ikke utføre den.',
        notAllowedToPerformAction:
            'Du har ikke tilgang til å utføre denne handlingen.',
        deleteLeverandor: {
            title: 'Slett skjema',
            confirmationText: 'Er du sikker på at du vil slette skjema?',
        },
        sendKommentar: {
            title: 'Send kommentar til rolleinnehaver',
            selectRole: 'Velg rolle',
            commentLabel: 'Kommentar',
            send: 'Send',
        },
        opprettLeverandor: {
            title: 'Opprett leverandørskjema',
        },
        createLeverandor: {
            title: 'Opprett leverandørskjema',
            button: 'Opprett leverandørskjema',
            navigateToSchema: 'Gå til skjema',
            successfulOperation: 'Leverandør opprettet vellykket.',
            existingProcessFound:
                'En prosess for denne leverandøren eksisterer allerede.',
            validation: {
                regionRequired: 'Region er påkrevd',
                orgnummerRequired: 'Organisasjonsnummer er påkrevd',
                orgnummerDigits: 'Organisasjonsnummer må bare bestå av tall',
                typeRequired: 'Type er påkrevd',
                countryRequired: 'Land er påkrevd',
            },
            region: {
                label: 'Velg region for leverandøren',
                oslo: 'Oslo',
                trondheim: 'Trondheim',
                sverige: 'Sverige',
                danmark: 'Danmark',
                europa: 'Europa',
            },
            country: {
                Norway: 'Norge',
                Sweden: 'Sverige',
                Denmark: 'Danmark',
                UnitedKingdom: 'Storbritannia',
                Other: 'Andre',
            },
            orgnummer: {
                label: 'Velg virksomhet',
                placeholder: 'Søk på navn eller org.nummer',
                placeholderSweden: 'Søk på org.nummer',
            },
            manualEntry: {
                nameLabel: 'Virksomhetsnavn',
                namePlaceholder: 'Skriv inn virksomhetsnavn',
                orgNumberLabel: 'Organisasjonsnummer',
                orgNumberPlaceholder: 'Skriv inn org.nummer',
                countryLabel: 'Land',
                countryPlaceholder: 'Skriv inn land',
            },
            superOffice: {
                label: 'SuperOffice-kontakt',
                loading: 'Søker i SuperOffice...',
                notFoundAlert: 'Intet eksisterende firma funnet',
                notFoundAlertDescription:
                    'Et nytt firma vil bli opprettet i SuperOffice',
                foundAlert: 'Eksisterende firma funnet',
                foundAlertDescription:
                    'Eksisterende firma vil bli brukt: {{navn}}',
                error: 'Feil ved søk i SuperOffice',
                selectOption: 'Velg firma',
                companyId: 'SuperOffice firma-ID',
                klassifisering: 'Klassifisering',
            },
            duplicateSuperofficeContactsFound:
                '{{count}} eksisterende SuperOffice-firmaer funnet for denne organisasjonen. Vennligst velg hvilket du vil bruke:',
            type: {
                label: 'Type',
                fastleverandor: 'Leverandør',
                engangsleverandor: 'Engangsleverandør',
                engangsleverandorInfo:
                    'En engangsleverandør kan bare brukes en gang for beløp mindre enn 15 000 NOK/15 000 SEK/10 000 DKK (eks. MVA)',
            },
        },
        TildelKommentarer: {
            field: {
                label: 'Kommentar ved tildeling',
                placeholder: 'Skriv inn en kommentar til personen du tildeler',
                error: {
                    commentTooLong:
                        'Kunne ikke lagre kommentaren i skjemaet. Kommentaren er for lang og overskrider tillatt lengde.',
                },
            },
            list: {
                title: 'Kommentarer ved tildeling',
                empty: 'Ingen kommentarer',
            },
        },
        rolleKommentarer: {
            list: {
                title: 'Kommentarer',
                empty: 'Ingen kommentarer',
                reply: 'Svar',
                replyTo: 'Svar til {{role}}',
                cannotDelete: 'Kan ikke slette kommentarer med svar',
                fra: 'Fra',
                til: 'Til',
                svarTil: 'Svar til',
            },
            field: {
                error: {
                    commentTooLong:
                        'Kommentaren er for lang og overskrider tillatt lengde.',
                },
            },
        },

        risikovurdering: {
            openButton: 'Åpne Risikovurdering',
            updateButton: 'Fyll ut felter med verdier fra Risikovurdering',
            button: 'Risikovurdering',
            notFoundInDNB:
                'Kan ikke finne leverandør i DNB for risikovurdering',
            fieldsUpdated: 'Feltene har blitt oppdatert',
            updateError: 'Feil ved oppdatering av felter',
            fetchError: 'Feil ved henting av risikovurderingsdata',
        },
        inherentRisk: {
            breadcrumb: 'Iboende risiko',
            title: 'Bransjer - Iboende risiko',
            subtitle: 'Vurdering av iboende risiko for ulike bransjer',
            selectRiskLabel: 'Velg risikonivå',
            low: 'Lav risiko',
            medium: 'Medium risiko',
            high: 'Høy risiko',
            notSet: 'Ikke satt',
            searchPlaceholder: 'Søk etter bransje',
            success: 'Risikovurdering oppdatert',
            error: 'Feil ved oppdatering av risikovurdering',
            table: {
                bransje: 'Bransje',
                beskrivelse: 'Beskrivelse',
                risk: 'Risikonivå',
            },
        },
        schemaRisk: {
            low: 'Lav',
            medium: 'Medium',
            high: 'Høy',
            schemaWarning:
                'Leverandørens vurdering viser høy risiko ifm. Åpenhetsloven. Lucas van Laack (bærekraftsleder) vil bli inkludert i prosessen for en vurdering av aktsomhet og videre oppfølging. Husk at bestilleren alltid er risikoeier.',
            schemaSafe:
                'Leverandørens vurdering viser lav eller medium risiko ifm. Åpenhetsloven. Ingen tiltak nødvendig.',
        },
        processId: 'Prosess-ID',
        startDate: 'Startdato',
        startedBy: 'Startet av',
        region: 'Region',
    },
    project: {
        title: 'Prosjekt- og tiltaksskjemaer',
        header: {
            documentation: 'Dokumentasjon',
            fullmakt: 'Fullmaktsgrenser',
        },
        noContextSelected: 'Du må søke opp en byggavdeling før du kan se dette',
        notFound:
            'Prosjektet du prøver å åpne finnes ikke. Vennligst gå tilbake til oversikten og velg et prosjekt fra listen.',
        backButton: 'Tilbake til prosjektoversikten',
        backButtonHistorikk: 'Tilbake til prosjektsammendraget',
        menuItems: {
            root: 'Prosjekt / tiltak',
            schema: 'Skjema',
            report: 'Rapport',
        },
        abort: 'Avbryt',
        review: 'Gjennomgang',
        opprettetAv: 'Opprettet av',
        completedBy: 'Utført av: {{name}}\n{{date}}',
        completedDate: 'Utført: {{date}}',
        tildelt: 'Tildelt:',
        ansvarlig: 'Ansvarlig: {{name}}',
        formFields: {
            aarsbudsjett: 'Årsbudsjett',
            mainTitle: 'Prosjekt- og tiltaksskjema',
            generelleOpplysningerTitle: 'Generelle opplysninger',
            eiendomsnavn: 'Eiendomsnavn',
            delAvEiendom: 'Del av eiendom',
            utleieareal: 'Utleieareal',
            prosjektareal: 'Prosjektareal',
            informationOmProsjekt: 'Informasjon om prosjekt',
            oppstartsdato: 'Oppstartsdato',
            mvapliktig: 'Er leietaker mva-pliktig (0-100%)?',
            opprettetSuperOffice: 'Er prosjektet opprettet i SuperOffice?',
            lonnsomhetsberegning:
                'Lønnsomhetsberegning er godkjent av leder for avdelingen og lagret i SuperOffice?',
            lonnsomhetsberegningLink:
                'Link til lønnsomhetsberegning i SuperOffice',
            signertLeietaker: 'Mottatt leieavtale signert av leietaker?',
            signertLeietakerLink: 'Link til signert leieavtale',
            signertKLP: 'Leieavtale signert av KLP?',
            prosjektBudsjett: 'Prosjektbudsjett',
            prosjektokonomiTitle: 'Prosjektøkonomi',
            budsjettert: 'Budsjettert?',
            pbv1: 'PB V1',
            andelKostnadsforing: 'Andel kostnadsføring (0-100%)',
            leietakerTitle: 'Leietaker',
            firmanavn: 'Firmanavn',
            firmanavnSøkeresultat: 'Firmanavn (søkeresultat)',
            organisasjonsnummer: 'Organisasjonsnummer',
            sendVidereTilTitle: 'Send videre til',
            prosjektleder: 'Prosjektleder',
            utviklingsdirektor: 'Utviklingsdirektør',
            kommentarerTitle: 'Kommentarer',
            kommentarForvaltningsdirektor: 'Kommentar - forvaltningsdirektør',
            kommentarForvaltningsdirektorGodkjent:
                'Prosjektet er godkjent av Forvaltningsdirektør med følgende kommentar',
            kommentarUtviklingsdirektor: 'Kommentar - utviklingsdirektør',
            kommentarUtviklingsdirektorGodkjent:
                'Prosjektet er godkjent av Utviklingsdirektør med følgende kommentar',
            kommentarAdministrerendedirektor:
                'Kommentar - administrerende direktør',
            kommentarAdministrerendedirektorGodkjent:
                'Prosjektet er godkjent av Administrerende direktør med følgende kommentar',
            kommentarProsjektdirektor: 'Kommentar - prosjektdirektør',
            kommentarProsjektdirektorGodkjent:
                'Prosjektet er godkjent av Prosjektdirektør med følgende kommentar',
            prosjektcontroller: 'Prosjektkontroller',
            andreSystemerTitle: 'Andre systemer',
            prosjektNummerAxapta:
                'Opprettet i Axapta og følgende er riktig prosjektnummer',
            firmaDetaljer: {
                registrertIMvaregisteret: 'Registrert i MVA-registeret',
                registrertIForetaksregisteret:
                    'Registrert i Foretaksregisteret',
                registreringsdatoEnhetsregisteret:
                    'Registrert i enhetsregisteret',
                registreringsdatoAntallAnsatteNAVAaregisteret:
                    'Registrert i NAV Aa-registeret',
                konkurs: 'Konkurs',
                underAvvikling: 'Under avvikling',
                underTvangsavviklingEllerTvangsopplosning:
                    'Under tvangsavvikling eller tvangsoppløsning',
            },
            manuellRegistrering: 'Manuell registrering',
            firmanavnManuell: 'Firmanavn',
            manueltRegistrertInfo:
                'Manuelt registrert — ingen data fra Brønnøysundregisteret',
            radioGroup: {
                yes: 'Ja',
                no: 'Nei',
            },
            leverandorListe:
                'Innkjøp og evaluering av tilbud iht. rutine DV1-2- RU004 Innkjøp teknisk avdeling',
            begrunnelseLeverandor: 'Begrunnelse for valg av leverandør',
            calculatedSelectorEditable: {
                editedLabel:
                    'Den automatisk kalkulerte verdien på {{value}} har blitt overskrevet. Du kan tilbakestille den ved å trykke på krysset i feltet over.',
            },
        },
        steps: {
            step1: {
                title: 'Definer prosjekt',
                description: 'Definer prosjekt',
            },
            step2: {
                title: 'Kontroller og korriger',
                description: 'Kontroller og korriger',
            },
            step3: {
                title: 'Forvaltningsdirektør godkjenning',
                description: 'Forvaltningsdirektør godkjenning',
            },
            step4: {
                title: 'Utviklingsdirektør godkjenning',
                description: 'Utviklingsdirektør godkjenning',
            },
            step5: {
                title: 'Administrerende direktør godkjenning',
                description: 'Administrerende direktør godkjenning',
            },
            step6: {
                title: 'Prosjektkontroller',
                description: 'Prosjektkontroller',
            },
        },
        opprettProsjekt: {
            title: 'Opprett prosjekt / tiltakskjema',
            type: 'Type',
            step: 'Steg',
            selectStep: 'Velg steg',
            noStepSelected: '--- Ingen verdi ---',
            superOfficeProsjekt: 'SuperOffice-prosjekt',
            superOfficeProsjektPlaceholder: 'Søk etter SuperOffice-prosjekt',
            opprettProsjektKnapp: 'Opprett prosjekt / tiltakskjema',
            goToSuperOffice: 'Gå til SuperOffice',
            prosjektskjematype: {
                label: 'Velg prosjektskjematype',
                hovedprosjekt: 'Hovedprosjekt',
                underprosjekt: 'Underprosjekt',
            },
            // Skal det gjennomføres en analyse av kostnader og lønnsomhet for prosjektet, velg «Lønnsomhetsberegning». \n\n
            LTT: 'Er det behov for forprosjekt, enten for å utarbeide tilbud til leietaker, eller tilbudsforespørsel til entreprenører velger du «Forprosjekt». \n\nEr leiekontrakten signert og prosjektleder har valgt entreprenør kan du gå rett til «Gjennomføring».',
            KOM: 'Har du behov for å utarbeide noen enkle skisser eller gjøre andre mindre undersøkelser i forkant av et forprosjekt, og som har en totalkostnad mindre enn 50.000,- velger du «Skisse». \n\nHar du behov for en prosjektleder, eller totalkostnaden for skisser og undersøkelser overskrider 50.000,- velger du «Forprosjekt».',
            TEK: 'Med forprosjekt?',
            prosjekterNotFound:
                'Ingen prosjekter funnet, gå til SuperOffice for å opprette prosjekt',
            radioGroup: {
                Lonnsomhetsberegning: {
                    title: 'Lønnsomhetsberegning',
                },
                Skisse: {
                    title: 'Skisse',
                    KOM: 'Det er behov for å utarbeide noen enkle skisser eller gjøre andre mindre undersøkelser i forkant av et forprosjekt, og har en totalkostnad mindre enn 50.000,-',
                },
                Forprosjekt: {
                    title: 'Forprosjekt',
                    LTT: 'Det er behov for forprosjekt, enten for å utarbeide tilbud til leietaker, eller tilbudsforespørsel til entreprenører',
                    KOM: 'Det er behov for en prosjektleder, eller totalkostnaden for skisser og undersøkelser overskrider 50.000,-',
                    TEK: 'Det er behov for forprosjekt, enten for å utarbeide tilbud til leietaker, eller tilbudsforespørsel til entreprenører',
                },
                Gjennomforing: {
                    title: 'Gjennomføring',
                    LTT: 'Kontrakten er signert og prosjektleder har valgt entreprenør',
                    TEK: 'Kontrakten er signert og prosjektleder har valgt entreprenør',
                },
                Tilbud: {
                    title: 'Tilbud',
                },
            },
            disabledButton:
                'For å opprette et prosjektskjema må du velge type og underkategori',
            occupiedProject: ' --- PROSJEKTET ER OPPTATT ---',
            types: {
                LTT: 'Leietakertilpasning (LTT)',
                KOM: 'Kommersiell (KOM)',
                TEK: 'Teknisk (TEK)',
                TILTAK: 'Tiltak',
            },
        },
        types: {
            LTT: 'Leietakertilpasning',
            LTT_Abbreviation: 'LTT',
            KOM: 'Kommersiell',
            KOM_Abbreviation: 'KOM',
            TEK: 'Teknisk',
            TEK_Abbreviation: 'TEK',
            TILTAK: 'Tiltak',
            Unknown: 'Ukjent type',
        },
        subTypes: {
            Opprettelse: 'Opprettelse',
            Skisse: 'Skisse',
            Igangsettelse: 'Igangsettelse',
            Bestilling: 'Bestilling',
            Forprosjekt: 'Forprosjekt',
            Gjennomforing: 'Gjennomføring',
            Endring: 'Endring',
            Avslutning: 'Avslutning',
        },
        stepTypes: {
            Ny: 'Ny',
            Avvist: 'Avvist',
            Fullfort: 'Fullført',
        },
        errors: {
            invalidLink: 'Linken er ikke gyldig',
            invalidProjectNumber:
                'Prosjektnummer må være på formen "<Firmanummer>.<D365 løpenummer(4 siffer)>" f.eks "N202.0435"',
            savePrompt: 'Det skjedde en feil ved lagring av innhold i skjema.',
            companyNotSelected:
                'Vennligst søk etter virksomhetens navn eller nummer og velg én fra listen',
            invalidOrgnumber: 'Ugyldig organisasjonsnummer',
            invalidTotalVurderingsskjema:
                'Ugyldig sum - verdien må være større enn 0',
        },
    },
    prosjekt: {
        cantFindProjectSchema: 'Det oppstod en feil. Fant ikke prosjektskjema',
        oppslag: {
            sokLabel: 'Søk (prosjektnummer, prosjektnavn eller eiendom)',
        },
        activityAssignedToOtherUser:
            "Oppgaven er tildelt '{{assigned}}', du kan derfor ikke endre/utføre oppgaven.",
        assignActivityToMe: 'Tildel oppgaven til meg',
        insufficientUserRole:
            "Oppgaven krever rollen '{{role}}', du er ikke tildelt denne rollen.",
        notCandidateGroupOwner:
            "For å fullføre denne oppgaven må du være tildelt rollen '{{owner}}'. Dine roller er '{{userRoles}}'",
        adminInformation:
            "Oppgaven krever rollen '{{role}}' og er tildelt '{{assigned}}'. Du har admin-rolle og kan endre/utføre oppgaven.",
        completedActivity: 'Oppgaven er allerede utført.',
        rejectedActivity: 'Skjemaet er avvist.',
        skipActivity:
            'Denne oppgaven er ikke relevant for flyten og vil bli hoppet over',
        processDefinition: {
            breadcrumb: 'Flytdiagram',
            back: 'Tilbake til dokumentasjon',
            title: 'Visuell fremstilling av flytdiagram for prosessdefinisjon: {{processDefinitionId}}',
            iconTitle:
                'Se mer detaljert fremstilling av flytdiagram for prosessdefinisjoner',
            documentationTitle:
                'Dokumentasjon av flytdiagram for prosessdefinisjoner',
            selector: 'Velg prosessdefinisjon',
            helperText: 'Velg prosessdefinisjon for å filtrere prosjekter',
            zoomIn: 'Zoom inn',
            zoomOut: 'Zoom ut',
            resetZoom: 'Nullstill zoom',
            read: 'Åpne ekstern lenke til Confluence side for prosessdefinisjon(er)',
        },
        definitions: {
            prosjekt_ltt_tilbud: 'Leietakertilpasning - Tilbud',
            prosjekt_ltt_godkjenning: 'Leietakertilpasning - Forprosjekt',
            prosjekt_ltt_bestilling: 'Leietakertilpasning - Gjennomføring',
            prosjekt_ltt_endring: 'Leietakertilpasning - Endring',
            prosjekt_ltt_avslutning: 'Leietakertilpasning - Avslutning',
            prosjekt_kom_skisse: 'KOM - Skisse',
            prosjekt_kom_opprettelse: 'KOM - Forprosjekt',
            prosjekt_kom_bestilling: 'KOM - Gjennomføring',
            prosjekt_kom_endring: 'KOM - Endring',
            prosjekt_kom_avslutning: 'KOM - Avslutning',
            prosjekt_tek_igangsettelse: 'TEK - Forprosjekt',
            prosjekt_tek_bestilling: 'TEK - Gjennomføring',
            prosjekt_tek_endring: 'TEK - Endring',
            prosjekt_tek_avslutning: 'TEK - Avslutning',
            tiltak_gjennomforing: 'Tiltak - Gjennomføring',
            tiltak_avslutning: 'Tiltak - Avslutning',
        },
        fullmakt: {
            breadcrumb: 'Fullmaktsgrenser',
            title: 'Fullmaktsgrenser for prosjektskjema',
            subtitle:
                'Oversikt over fullmakter og godkjenningsmyndigheter. Alle beløp er ekskl. MVA.',
            groupBy: 'Grupper etter:',
            noGroup: 'Vis alle',
            table: {
                allTitle: 'Alle fullmakter',
                region: 'Region',
                avdeling: 'Avdeling',
                stilling: 'Stilling',
                innenfor: 'Budsjettert',
                utover: 'Ikke budsjettert',
                endring: 'Endring i budsjett',
            },
        },
        statuses: {
            TilbudUnderGodkjenning: 'Tilbud under godkjenning',
            Tilbud: 'Tilbud',
            UnderSkissering: 'Under skissering',
            Skissert: 'Skissert',
            LonnsomhetsberegningUnderGodkjenning:
                'Lønnsomhetsberegning under godkjenning',
            Lonnsomhetsberegning: 'Lønnsomhetsberegning',
            ForprosjektUnderGodkjenning: 'Forprosjekt under godkjenning',
            Forprosjekt: 'Forprosjekt',
            GjennomforingUnderGodkjenning: 'Gjennomføring under godkjenning',
            Gjennomforing: 'Gjennomføring',
            TilEndring: 'Endring budsjett under godkjenning',
            Endret: 'Gjennomføring endret budsjett',
            TilAvslutning: 'Avslutning under godkjenning',
            Avsluttet: 'Avsluttet',
            Avvist: 'Avvist',
        },
        table: {
            actionMenuItems: {
                stepHeader: 'Opprett skjema for',
                currentHeader: "Handlinger for '{{stegNavn}}'",
                Igangsettelse: 'Igangsettelse',
                Skisse: 'Skisse',
                Tilbud: 'Tilbud',
                Forprosjekt: 'Forprosjekt',
                Godkjenning: 'Godkjenning',
                Gjennomforing: 'Gjennomføring',
                Endring: 'Endring budsjett',
                Avslutning: 'Avslutning',
                detaljer: 'Vis detaljer',
                tildel: 'Tildel ny ansvarlig',
                tildelRolle: 'Tildel ny: {{rolle}}',
                sammendrag: 'Vis sammendrag',
                sendReminder: 'Send påminnelse til ansvarlig',
                sendReminderName: 'Send påminnelse til {{name}}',
                dokumentasjon: 'Vis dokumentasjon',
                kalkyle: 'Åpne Kostnadskalkyle',
            },
            tildelAnsvarlig: {
                title: 'Tildel ny ansvarlig',
                ansvarlig: 'Ansvarlig',
                tildel: 'Tildel',
                avbryt: 'Avbryt',
                Prosjekteier: 'Prosjekteier',
                Prosjektleder: 'Prosjektleder',
                Forvaltningsdirektor: 'Forvaltningsdirektør',
                Utviklingsdirektor: 'Utviklingsdirektør',
                Administrerendedirektor: 'Administrerende direktør',
            },
            roller: {
                Prosjekteier: 'Prosjekteier',
                Prosjektleder: 'Prosjektleder',
                Forvaltningsdirektor: 'Forvaltningsdirektør',
                Utviklingsdirektor: 'Utviklingsdirektør',
                Administrerendedirektor: 'Administrerende direktør',
                Prosjektdirektor: 'Prosjektdirektør',
                Okonomisjef: 'Økonomisjef',
                Prosjektkontroller: 'Prosjektkontroller',
                Okonomi: 'Regnskapsansvarlig',
                Teknisksjef: 'Teknisk sjef',
                Eiendomssjef: 'Eiendomssjef',
                Regiondirektor: 'Regiondirektør',
                Ukjent: 'Ingen roller',
            },
            subTypes: {
                Forprosjekt: 'Forprosjekt',
                Gjennomforing: 'Gjennomføring',
                Endring: 'Endring',
                Avslutning: 'Avslutning',
                Tilbud: 'Tilbud',
            },
            registreringStatus: {
                Ny: 'Ny',
                Avvist: 'Avvist',
                Fullfort: 'Fullført',
            },
            tableTitle: 'Utførte oppgaver i steget',
            type: 'TYPE',
            navn: 'NAVN',
            d365Prosjektnummer: 'NUMMER',
            eiendom: 'EIENDOM',
            rolle: 'ROLLE(R)',
            email: 'E-POST',
            signeringsDato: 'SIGNERINGS DATO',
            beskrivelse: 'BESKRIVELSE',
            status: 'STATUS',
            opprettetAv: 'OPPRETTET AV',
            endretAv: 'ENDRET AV',
            ansvarlig: 'TILDELT TIL',
            startDato: 'STARTDATO',
            sluttDato: 'SLUTTDATO',
            fullfortDato: 'FULLFØRT DATO',
            action: 'HANDLING',
            utforelseDato: 'DATO FOR UTFØRELSE',
            oppgave: 'OPPGAVE',
            prosjekteier: 'PROSJEKTEIER',
            prosjektleder: 'PROSJEKTLEDER',
            emptyTableMessage:
                'Vi finner ingen prosjekt basert på filterene du har valgt.',
            lastNedDokument: 'Last ned dokument',
            forhaandsvisDokument: 'Forhåndsvis dokument',
            visDetaljertProsjektregistrering:
                'Vis detaljert oversikt av det valgte prosesssteget',
            visProsjektSkjema: 'Vis skjema',
            visProsjektISuperoffice: 'Åpne prosjekt i SuperOffice',
            prosjektskjematype: 'PROSJEKTSKJEMATYPE',
            aapneISuperOffice: 'Åpne prosjekt i SuperOffice',
        },
        filter: {
            prosjektskjematype: {
                label: 'Skjematype',
                all: 'Alle',
                hovedprosjekt: 'Hovedprosjekter',
                underprosjekt: 'Underprosjekter',
            },
        },
        summary: {
            title: 'Prosjektsammendrag - {{prosjektNavn}}',
        },
        notification: 'Behandler forespørselen. Vennligst vent..',
        error: 'Det oppstod en feil. Prøv igjen senere.',
        deleteProject: {
            title: 'Slett skjema',
            confirmationText: 'Er du sikker på at du vil slette skjema?',
        },
        successfulRegistration: 'Prosjektet har blitt registrert.',
        successfulOperation: 'Handlingen ble utført vellykket.',
        notAssignedToUser:
            'Du er ikke tildelt denne oppgaven og kan derfor ikke utføre den.',
        notAllowedToPerformAction:
            'Du har ikke tilgang til å utføre denne handlingen.',
        newProcess: 'Nye prosjekter',
        ongoingProcessForvalter: 'Hos forvalter',
        ongoingProcessFinance: 'Hos økonomi',
        startRegistration: 'Start registrering',
        declined: 'Avvist',
        approved: 'Godkjent',
        forApproval: 'Til godkjenning',
        assignedToMe: 'Tildelt meg',
        avvistKommentarTitle:
            "Oppgaven '{{avvistOppgave}}' er avvist med følgende kommentar:",
        stepper: {
            unathorisedStep: 'Du har ikke tilgang til dette steget',
        },
        vurderingsskjema: {
            close: 'Lukk',
            open: 'Åpne vurderingsskjema',
            title: 'Vurderingsskjema',
            sum: 'Sum: ',
            oppsummeringAvSummer: 'Oppsummering av summer',
            sumAlleKategorier: 'Alle kategorier: ',
            sumAktivering: 'Aktivering: ',
            sumKostnadsforing: 'Kostnadsføring: ',
            sumAndelAktivering: 'Andel aktivering: ',
            sumAndelKostnadsforing: 'Andel kostnadsføring: ',
            navn: 'Navn',
            kostkategoriId: 'KostkategoriId',
            kostnadsforing: 'Kostnadsføring',
            aktivering: 'Aktivering',
            total: 'Total',
            totalOversikt: 'Total basert på skjema',
            kommentar: 'Kommentar',
            inputMode: {
                toggleLabel: 'Registrer med totalsum og prosentfordeling',
                helperText:
                    'Skriv inn totalsum og prosent per rad; aktivering og kostnadsføring beregnes automatisk.',
                aktiveringPct: 'Aktivering %',
                kostnadsforingPct: 'Kostnadsføring %',
            },
            error: {
                paakrevdKommentar: 'Kommentar påkrevd',
                hasErrors: 'Skjema har {{count}} feil',
                hasErrors_1: 'Skjema har 1 feil',
            },
        },
        kostnadskalkyle: {
            title: {
                tab: 'Kostnadskalkyle',
                general: 'Kalkyle og lønnsomhetsberegning for prosjekt',
                kalkyle: 'Kalkyle for prosjekt: {{prosjektNavn}}',
                lonsomhetsberegning:
                    'Lønnsomhetsberegning for prosjekt: {{prosjektNavn}}',
                modalButton: 'Åpne kalkyle',
            },
            submit: 'Lagre kalkyle',
            administrerKostnadstyper: 'Administrer kostnadstyper',
            disabledTab: 'Deaktivert for denne prosjekttypen',
            leggTilKostnadstype: 'Legg til kostnadstype',
            addKostnadstype: {
                name: 'Navn',
                duplicateError: "Kostnadstypen '{{name}}' finnes allerede",
            },
            velgKostnadstype: 'Velg kostnadstype',
            kostnadstypeWarning: 'Valgt kostnadstype er markert som slettet',
            velgKostkategori: 'Velg kostkategori',
            lagrer: 'Lagrer',
            lagre: 'Legg til',
            prosjektArealM2: 'Prosjektareal (kvm)',
            risikotilleggSats: 'Sats for risikotillegg (%)',
            prosjektlederSats: 'Sats for prosjektleder-timer (%)',
            tillegg: {
                title: 'Tillegg',
                risiko: 'Risiko',
                prosjektleder: 'Prosjektleder',
                time: 'time',
                timer: 'timer',
            },
            leieobjektArealM2: 'Leieobjekt inkl. andel fellesareal (kvm)',
            kontraktsleiePerM2: 'Kontraktsleie pr. m²',
            leieperiode: 'Leieperiode (år)',
            aarligLeie: 'Årlig leie',
            totalLeie: 'Total leie',
            error: {
                kostnadstypeRequired: 'Kostnadstype er påkrevd',
                satsRequired: 'Sats er påkrevd',
                satsRange: 'Sats må være mellom 0 og 100',
                enhetRequired: 'Enhet er påkrevd',
                enhetPositive: 'Enhet må være større enn 0',
                prisPerEnhetRequired: 'Pris per enhet er påkrevd',
                prisPerEnhetPositive: 'Pris per enhet må være større enn 0',
                andelKostnadsforingRequired: 'Andel kostnadsføring er påkrevd',
            },
            table: {
                kostnadstype: 'Kostnadstype',
                beskrivelse: 'Beskrivelse',
                kostnad: 'Kostnad',
                enhet: 'Antall (stk/m/m²)',
                prisPrEnhet: 'Pris pr enhet',
                aktiveringsandel: 'Aktiveringsandel (%)',
                kostnadsforingAndel: 'Andel kostnadsføring (%)',
                sumAktivering: 'Sum aktivering',
                handlinger: 'Handlinger',
                addRow: 'Legg til linje',
            },
            summary: {
                section_project: 'Nøkkeltall om prosjektet',
                totalKostnad: 'Totalkostnad',
                kvadratMeterPris: 'Kvadratmeterpris',

                section_historical: 'Historiske nøkkeltall på eiendommen',
                gjennomsnittligKostnadPerM2: 'Gjennomsnittlig kostnad pr m²',

                section_financial: 'Nøkkeltall for regnskap',
                andelAktiveres: 'Andel aktiveres',
                andelKostnadsfores: 'Andel kostnadsføres',
            },
        },
        lonnsomhet: {
            title: 'Lønnsomhet',
            fields: {
                kontraktleieTotaltPerAar: 'Total kontraktsleie/år',
                grunnleiePerM2: 'Grunnleie per m²',
                oktLeiePerM2PerAar: 'Økt leie per m²/år',
                nyGrunnleiePerM2PerAar: 'Ny grunnleie per m²/år',
                inflasjon: 'Inflasjon (%)',
                avkastningskrav: 'Avkastningskrav (%)',
                realAvkastningskrav: 'Realavkastningskrav (%)',
                oktInntektPerM2PerAar: 'Økt inntekt per m²/år',
                oktInntektPerAar: 'Økt inntekt/år',
                terminerPerAar: 'Terminer per år',
                kontraktstid: 'Kontraktstid (år)',
            },
            table: {
                navn: 'Navn',
                investeringskostnad: 'Investering',
                avskrivningstid: 'Avskrivningstid',
                restverdi: 'Restverdi (%)',
                aarligOktLeiepris: 'Tilleggsleie per år (kr/år)',
                oktLeieprisPerM2: 'Tilleggsleie per m² (kr/m²/år)',
                leggTilDelprosjekt: 'Legg til delprosjekt',
                totalt: 'Total',
                nettoLeie: 'Netto leie',
                inkluderMvaKompensasjon: 'Inkluder MVA',
                noData: 'Det er ingen data i kostnadskalkylen ennå. Fyll gjerne ut skjemaet der for å se lønnsomhetsberegningen.',
            },
        },
        kostnadstyper: {
            title: 'Kostnadstyper',
            showDeleted: 'Vis slettede kostnadstyper',
            table: {
                navn: 'Navn',
                kostkategori: 'Kostkategori',
                defaultCost: 'Default kostnad',
                defaultKostnadsforingAndel: 'Default andel kostnadsføring (%)',
                edit: 'Rediger kostnadstype',
                save: 'Lagre kostnadstype',
                add: 'Legg til kostnadstype',
                delete: 'Slett kostnadstype',
                deletePrompt:
                    'Sletting av kostnadstype gjør den utilgjengelig for fremtidig bruk. Eksisterende bruk i kalkyler påvirkes ikke.',
                deleteConfirm: 'Slett',
                cancel: 'Avbryt',
                restore: 'Gjenopprett kostnadstype',
                duplicateError:
                    'En kostnadstype med samme navn og kostkategori finnes allerede',
            },
            error: {
                navnRequired: 'Navn er påkrevd',
                kostKategoriRequired: 'Kostkategori er påkrevd',
                duplicate:
                    'Kostnadstypen med navn {{name}} og kostkategori {{kostkategori}} finnes allerede',
            },
        },
        leverandor: {
            organizationSelect: 'Forespurt virksomhet',
            organizationPlaceholder: 'Orgnummer/navn',
            price: 'Pris',
            priceRevised: 'Korrigert pris',
            selected: 'Valgt',
            klassifisering: 'Klassifisering',
            add: 'Legg til',
        },
        vedlegg: {
            add: 'Legg til vedlegg',
            delete: 'Slett vedlegg',
            loading: 'Laster opp vedlegg',
        },
        budsjettnummer: {
            title: "Budsjett '{{number}}' i D365",
            period: 'Periode: {{from}} - {{to}}',
            budget: 'ExMVA: {{exMva}}, MVA: {{mva}}, Totalt: {{total}}',
        },
        dokument: {
            add: 'Legg til',
            loading: 'Laster opp',
        },
        TildelKommentarer: {
            field: {
                label: 'Kommentar ved tildeling',
                placeholder: 'Skriv inn en kommentar til personen du tildeler',
                error: {
                    commentTooLong:
                        'Kunne ikke lagre kommentaren i skjemaet. Kommentaren er for lang og overskrider tillatt lengde.',
                },
            },
            list: {
                title: 'Kommentarer ved tildeling',
                empty: 'Ingen kommentarer',
            },
        },
    },
    frontPage: {
        buildings: 'Eiendom',
        buildingsLink: 'Mine eiendommer',
        contract: 'Kontrakter',
        frontpage: 'Forsiden',
        invoice: 'Faktura',
        invoiceLink: 'Alle fakturaer',
        messages: 'Oppslagstavle',
        messagesLink: 'Alle meldinger',
        mytasksLink: 'Saksoversikt',
        welcome: {
            forvalter: 'Velkommen til Eiendomsdashbord',
            yourAdminDashboard: 'Velkommen til Eiendomsdashbordet, {{name}}',
        },
        adjustFrontpage: {
            title: 'Tilpass forsiden',
            alert: 'Nå vises standardforsiden for din rolle. Du kan enkelt tilpasse forsiden etter dine behov nedenfor.',
            select: 'Velg hva som vises på forsiden',
            frontpageCardsSelector: {
                utestaaendeFordringer: 'Utestående fordringer',
                arealmessigUtleiegrad: 'Arealmessig utleiegrad',
                kontrakter: 'Kontrakter',
                prosjekter: 'Prosjekter/tiltak',
                saker: 'Saker',
                leverandor: 'Leverandør',
            },
        },
        survey: {
            title: 'Hei{{name}}!',
            description1:
                'Har du 5 minutter til å gi noen tilbakemeldinger om hvordan vi kan forbedre Eiendomsdashbordet?',
            description2: 'Vi i IT-avdelingen setter stor pris på hjelpen din!',
            linkText: 'Gå til spørreundersøkelsen',
        },
        expiredContracts: {
            actionButtonText: 'Se Ledige lokaler',
            area: 'Areal',
            areaRatio: 'Arealmessig utleiegrad',
            available: 'Ledig',
            contracts: 'Kontrakter',
            econRatio: 'Økonomisk utleiegrad',
            income: 'Leieinntekter',
            marketValue: 'Markedsverdi',
            nokperyear: 'NOK/År',
            rented: 'Utleid',
            rentedExpiring: 'Utløpende',
            title: 'Ledige lokaler',
            yourAvailableAreasDate: 'Mine ledige lokaler per ',
            yourRentedAreasDate: 'Mine utleide areal per ',
        },
        expiringContracts: {
            actionButtonText: 'Se utløpende kontrakter',
            title: 'Kontraktsutløp',
            yourExpiringContracts: 'Mine utløpende kontrakter',
            yourRentalRateDate: 'Min utleiegrad per ',
        },
        utestaaendeFordringer: {
            allReceivables: 'Se alle fordringer',
            actionButtonText: 'Se mine fordringer',
            emptyResult:
                'Det er ingen utestående fordringer du behøver å følge opp.',
            title: 'Utestående fordringer',
            subtitle: 'Kunder med utestående fordringer',
        },
        contractManagement: {
            actionButtonText: 'Kontraktsforvaltning',
            contractsToRegistration: 'Venter på registrering i D365',
            negotiations: 'Forhandlinger',
            signableContracts: 'Kontrakter til signering',
            subtitle: 'Kontraktsforvaltning',
            title: 'Kontrakter',
            newProsessLink: 'Start ny prosess',
            infoText: 'Denne kontraktoversikten filtreres ikke på valgt bygg.',
        },
        project: {
            actionButtonText: 'Prosjekt/tiltakskjema',
            subtitle: 'Prosjektforvaltning',
            title: 'Prosjekter/tiltak',
            newProjectLink: 'Opprett nytt prosjekt/tiltak',
            infoText: 'Denne prosjektoversikten filtreres ikke på valgt bygg.',
        },
        sak: {
            actionButtonText: 'Saksoversikt',
            subtitle: 'Saksoppfølgning',
            title: 'Saker',
            noTickets: 'Ingen saker',
            sakStatus: {
                Aktiv: 'Aktiv',
                Avsluttet: 'Avsluttet',
                Sammenslått: 'Sammenslått',
                Slettet: 'Slettet',
                Unknown: 'Ukjent',
                Utsatt: 'Utsatt',
                'Venter på 3dje part': 'Venter på 3dje part',
                'Venter på kunde': 'Venter på kunde',
                Påbörjad: 'Påbegynt',
                'Ej påbörjad': 'Ikke påbegynt',
            },
        },
        leverandor: {
            title: 'Leverandør',
            subtitle: 'Leverandør',
            assignedToMe: 'Tildelt meg',
            underAssessment: 'Under vurdering',
            completed: 'Fullført',
            rejected: 'Avvist',
            actionButtonText: 'Leverandørskjema',
        },
    },
    general: {
        backToTop: 'Tilbake til toppen',
        by: 'av',
        cancel: 'Avbryt',
        charactersRemaining: '{{count}} tegn igjen',
        clear: 'Tøm',
        clearList: 'Tøm listen',
        clearSelection: 'Fjern valget',
        close: 'Lukk',
        confirm: 'Ja',
        contextSelectorSearchField: 'Søk etter byggavdeling',
        contextSelectorHint: "Legg til byggavdeling i liste over 'Mine bygg'",
        days_0: 'dag',
        days: 'dager',
        decline: 'Nei',
        delete: 'Slett',
        deleteYes: 'Ja, slett',
        details: 'Detaljer',
        download: 'Last ned',
        draft: 'Utkast',
        edit: 'Redigér',
        emptyList: 'Listen er tom',
        error: {
            title: 'Feil',
            message: 'Det oppstod en feil. \n Vennligst prøv igjen senere.',
            messageWithDetails:
                'Det oppstod en feil: \n {{errorMessage}}. \n Vennligst prøv igjen senere.',
            apiErrorTitle: 'Feilmeldinger:',
            apiErrorTitle_1: 'Feilmelding:',
            apiError:
                'Det oppstod en feil ved henting av data. Utviklingsteamet har blitt varslet. Vi beklager ulempen.',
            reloadPage: 'Last inn siden på nytt',
        },
        expired: 'Utløpt',
        expiryTime: {
            expired: '(Har utløpt)',
            expires_within_6m: '(6 mndr)',
            expires_within_1y: '(1. år)',
            expires_within_2y: '(2 år)',
            expires_within_3y: '(3 år)',
            expires_within_4y: '(4 år)',
        },
        links: 'Lenker',
        goBack: 'Gå tilbake',
        goBackToFrontpage: 'Gå tilbake til forsiden',
        loading: 'Laster...',
        menu: 'Meny',
        month: 'Måned',
        month_0: 'Jan',
        month_1: 'Feb',
        month_2: 'Mar',
        month_3: 'Apr',
        month_4: 'Mai',
        month_5: 'Jun',
        month_6: 'Jul',
        month_7: 'Aug',
        month_8: 'Sep',
        month_9: 'Okt',
        month_10: 'Nov',
        month_11: 'Des',
        // tslint:disable-next-line: max-line-length
        noIe: 'Vi beklager, men denne funksjonen støttes ikke i Internet Explorer. Vi anbefaler å bruke Google Chrome eller Mozilla Firefox-nettleseren.',
        name: 'Navn',
        of: 'av',
        open: 'Åpne',
        pageNotFound: 'Fant ikke siden',
        preview: 'Forhåndsvis',
        previewDownload: 'FORHÅNDSVIS / LAST NED',
        publish: 'Publisér',
        readMore: 'Les mer',
        reload: 'Last inn på nytt',
        reset: 'Nullstill',
        revert: 'Tilbakestill',
        save: 'Lagre',
        saveAsDraft: 'Lagre som utkast',
        saved: 'Lagring vellykket',
        saving: 'Lagrer...',
        savingError: 'Feil under lagring',
        show: 'vis',
        showAll: 'Vis alle',
        submit: 'Send inn',
        sum: 'sum',
        updating: 'Oppdaterer...',
        unknown: 'Ukjent',
        wrote: 'skrev',
    },
    languageName: 'Norsk',
    report: {
        error: 'Feil ved lasting av rapporter.',
        name: {
            ArealOgKontrakt: 'Areal og kontrakter',
            Kundereskonto: 'Kundereskonto',
            Prosjekt: 'Prosjekt',
            Regnskap: 'Regnskap',
        },
        open: 'Åpne',
        report: 'Rapport',
        title: 'Rapporter',
    },
    tables: {
        antallTreff: '{{count}} treff',
        body: {
            noMatch: 'Beklager, vi fant ingen resultat',
            toolTip: 'Sorter',
            toolTipFor: 'Sorter på ',
        },
        pagination: {
            displayRows: 'av',
            next: 'Neste side',
            previous: 'Forrige side',
            rowsPerPage: 'Rader per side:',
        },
        toolbar: {
            downloadCsv: 'Last ned CSV',
            filterTable: 'Filtrer tabell',
            print: 'Skriv ut',
            search: 'Søk',
            viewColumns: 'Vis kolonner',
        },
        filter: {
            all: 'Alle',
            reset: 'Tilbakestill',
            title: 'FILTRE',
        },
        viewColumns: {
            title: 'Vis Kolonner',
            titleAria: 'Vis/skjul tabell kolonne',
        },
        selectedRows: {
            delete: 'Slett',
            deleteAria: 'Slett valgt rad',
            text: 'rad(er) valgt',
        },
        labelRowsPerPage: 'Rader per side:',
    },
    validator: {
        email: 'Gyldig epost er påkrevd!',
        required: 'Feltet er obligatorisk!',
    },
    sustainability: {
        prosjektAvfall: {
            title: 'Bærekraft i prosjekter',
            description:
                'Rapporten viser informasjon for avsluttede prosjekter innenfor gitt periode. Data for enkelte prosjekter er listet opp i tabellen.',
            fromDate: 'Avsluttet, fra dato',
            toDate: 'Avsluttet, til dato',
            reset: 'Nullstill til siste kvartal',
            uploadRapport: 'Last opp sluttrapport manuelt',
            projectLabel: 'Velg prosjekt',
            projectWarning:
                'Prosjekt har allerede en sluttrapport, denne vil overskrives av ny sluttrapport.',
            selectFile: 'Velg fil',
            uploadRapportSuccess: 'Sluttrapporten er lastet opp og analyseres.',
            sluttrapportLabel: 'Sluttrapport',
            lastOppRapport: 'Last opp sluttrapport',
            uploadKlimagass: 'Legg inn klimagassutslipp manuelt',
            lagreKlimagass: 'Lagre klimagassutslipp',
            updateKlimagassSuccess: 'Klimagassutslipp oppdatert',
            summary: 'Oppsummering',
            antallProsjekter: 'Antall prosjekter',
            antallProsjekterMedRapport: 'Antall prosjekter med sluttrapport',
            totalAvfall: 'Totalt avfall',
            sorteringsgrad: 'Sorteringsgrad',
            tableTitle: 'Prosjekter',
            prosjektnummer: 'Nummer',
            prosjekttype: 'Type',
            prosjektnavn: 'Navn',
            region: 'Region',
            byggtype: 'Eiendomstype',
            bygg: 'Eiendom',
            prosjektleder: 'Prosjektleder',
            klimagassberegning: 'Beregnet klimagassutslipp',
            klimagassRelevant: 'Klimagassberegning relevant',
            klimagassRelevantHint:
                'Prosjektleders svar ved oppstart: Er klimagassberegning (Reduzer e.l., A1–A5 etter NS 3720:2018) relevant for prosjektet?',
            klimagassForklaring: 'Begrunnelse (hvis nei)',
            relevantJa: 'Ja',
            relevantNei: 'Nei',
            lesMer: 'Les mer',
            prosjektSum: 'Avfallsvolum',
            document: 'Sluttrapport',
            documentTooltip: 'Vis sluttrapport',
            emptyTable: 'Fant ingen avsluttede prosjekter',
            sortert: 'Total sortert',
            usortert: 'Total usortert',
            sum: 'Sum',
            sorteringHeader: 'Sortering',
            avfallTypeHeader: 'Varegruppe',
            beskrivelseHeader: 'Beskrivelse',
            transporterHeader: 'Antall transporter',
            volumHeader: 'Avfallsvolum',
            volumAndelHeader: 'Andel',
            analyzeAction: 'Analyser rapport på ny',
            analyzeWarning:
                'Tidligere avfall for prosjektet vil bli overskrevet',
            editAction: 'Manuell redigering',
            addRow: 'Legg til rad',
            updateSuccess: 'Avfall oppdatert',
            error: {
                validation: 'Vennligst rett feilene før lagring',
                invalidMengde: 'Mengde må være større enn eller lik 0',
                invalidKlimagassberegning:
                    'Klimagassberegning må være større enn eller lik 0',
                typeRequired: 'Avfallstype er påkrevd',
            },
        },
    },
    reportMapping: {
        menu: {
            title: 'Energinet rapportkobling',
        },
        breadcrumbs: {
            reportMapping: 'Energinet rapportkobling',
            documentation: 'Dokumentasjon',
        },
        documentation: {
            title: 'Dokumentasjon',
            openExternal: 'Åpne ekstern lenke til Confluence side',
            backButton: 'Tilbake til rapportkobling',
            viewInConfluence: 'Åpne dokumentasjonen i Confluence',
        },
        mappingAdd: {
            title: 'Ny kobling',
            titleMappingFor: 'Ny kobling for rapport:',
            selectReport: 'Velg rapport',
            selectBuilding: 'Velg bygg',
            selectCustomer: 'Velg kunde',
            selectReportType: 'Velg rapporttype',
            searchBuildings: 'Søk etter bygg...',
            searchCustomers: 'Søk etter kunder...',
            searchReports: 'Søk etter rapporter...',
            save: 'Lagre',
        },
        mappingEdit: {
            title: 'Rediger kobling',
            titleMappingFor: 'Rediger kobling for rapport:',
            save: 'Oppdater',
        },
        mappingTransfer: {
            title: 'Overfør rapport',
            titleMappingFor: 'Overfør rapport:',
            transfer: 'Overfør',
            success:
                'Rapporten ble overført og synkronisert med andre systemer.',
            disclaimer:
                'NB! Ved lagring av rapporten vil den bli synkronisert med andre systemer. Det kan ta opp til 3 minutter. Vennligst ikke lukk vinduet før synkroniseringen er fullført.',
            disclaimerNightly:
                'Hvis du ikke vil overføre nå, blir rapportene overført ved nattlig synkronisering',
        },
        mappingTable: {
            type: 'Type',
            report: 'Rapport',
            building: 'Bygg',
            customer: 'Kunde',
            actions: 'Handlinger',
            filterByStatus: 'Filtrer etter status',
            all: 'Alle',
            mapped: 'Koblet',
            unmapped: 'Ikke koblet',
        },
        mappingDelete: {
            title: 'Slett koblingen',
            confirmationText:
                'Er du sikker på at du vil slette denne koblingen?',
        },
        mappingsSummary: {
            totalMappings: 'Rapporter',
            withBygg: 'Koblet til bygg',
            withKunde: 'Koblet til bygg og kunde',
        },
        error: {
            noAvailableReports:
                'Ingen tilgjengelige rapporter å koble til for valgte bygg.',
            saveFailed: 'Kunne ikke lagre rapporten. Vennligst prøv igjen.',
            transferFailed:
                'Rapporten ble lagret, men synkronisering med andre systemer feilet. Synkroniseringen vil bli forsøkt på nytt automatisk.',
        },
        reportType: {
            Unknown: 'Ukjent',
            Energy: 'Timeserie rapport på energibærere',
            Waste: 'Avfallsrapport på fraksjoner eller fraksjonsgrupper',
            MonthlyEnergy: 'Månedsrapport på energibærere',
            Water: 'Vannrapport på forbruk siste 24 måneder',
            AdjustedEnergy:
                'Graddagskorrigert energirapport, for i år relativt til siste 4 år',
            MonthlyCustomerEnergy:
                'Månedsrapport på energibærere (kun for kundeportalen)',
            CustomerSpecificEnergy: 'Energirapport som er spesifikk for kunde',
        },
    },
    devRoleSelector: {
        label: 'Valgt testrolle',
        heading: 'Velg testrolle',
        original: 'Original (ekte rolle)',
        forvalterKontor: 'Forvalter – Kontor (Asbjørn)',
        forvalterKjopesenter: 'Forvalter – Kjøpesenter (Carl Christian)',
        okonomi: 'Økonomi (Valarmathy)',
        okonomiQA: 'Økonomi QA (Solrunn)',
        prosjektleder: 'Prosjektleder/Prosjekteier (Henriette)',
    },
};
